import React from 'react'

function JackpotLocal(props) {
  const isSpecialBonus = props.type === 'special-bonus';
  return (
    <div className={`contJacpot ${isSpecialBonus ? 'contJacpot--special-bonus' : ''}`}>
      {isSpecialBonus && <div className="specialBonusBurst" aria-hidden="true"><i /><i /><i /></div>}
      <div className='gridJacpot'>
        <div className='textJack'>{isSpecialBonus ? 'BONO' : 'Jackpot'}</div>
        <div className='textTipo'>
          <span className='textLcl'>{isSpecialBonus ? 'ESPECIAL' : 'Local'}</span>
          </div>
        <div className='textMonto'>$ {props.value}</div>
        <div className='textTicket'>Ticket: {props.ticket}</div>
      </div>
    </div>
  )
}

export default JackpotLocal
